import { render } from "./Home.vue?vue&type=template&id=25138cc4"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=25138cc4&lang=scss"

import exportComponent from "/Users/pamelamontanez/Documents/projects/personal-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__